<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { service } from "./helper/Rest";

export default {
  name: "App",
  async beforeCreate() {
    var userId = window.localStorage.getItem("userId")
    if (userId) {
      var user = (await service.currentUser(userId)).data;
      this.$store.commit("currentUser", user);
      this.$store.commit("addCompanyData", user.business);
      this.$store.commit("changeColors", user.business);
      await this.$store.dispatch("GETCHECKPOINTS");
      await this.$store.dispatch("GETBUILDINGS");
    }
    
  }
};
</script>

<style lang="scss">
// @import "../src/assets/styles/1.settings/colors";
@import "../node_modules/buefy/dist/buefy.css";
@import "~bulma/sass/utilities/_all";
@import "../src/assets/styles/main";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue